import { useMemo } from 'react';
import { Trash2, Palette, SquarePen, Video } from 'lucide-react';
import SelectionActionMenu from '../features/floorPlanEditor/FloorPlanWorkspace/SelectionActionMenu.jsx';
import { getDefaultFloorPlanBlockedBounds } from '../features/floorPlanEditor/FloorPlanWorkspace/useOverlayPlacement.js';

export const ROOM_ACTIONS_ARC_RADIUS = 46;
export const ROOM_ACTIONS_RENDER_BTN_OFFSET = 100;

/**
 * @param {{
 *   anchor: { x: number; y: number };
 *   onDelete: () => void;
 *   onChangeColor: () => void;
 *   onEdit: () => void;
 *   onRenderRequest?: () => void;
 *   viewportRect?: { width: number; height: number } | null;
 *   onBoundsChange?: (bounds: { x: number; y: number; width: number; height: number; placement: string }) => void;
 * }} props
 */
function FloorPlanRoomActions({
  anchor,
  viewportRect = null,
  onDelete,
  onChangeColor,
  onEdit,
  onRenderRequest,
  onBoundsChange,
}) {
  const actions = useMemo(
    () => [
      { key: 'delete', title: 'Delete room', onClick: onDelete, Icon: Trash2 },
      { key: 'color', title: 'Floor material', onClick: onChangeColor, Icon: Palette },
      { key: 'edit', title: 'Edit room', onClick: onEdit, Icon: SquarePen },
    ],
    [onDelete, onChangeColor, onEdit],
  );

  const blockedBounds = viewportRect
    ? getDefaultFloorPlanBlockedBounds(viewportRect.width, viewportRect.height)
    : [];

  const extraContent = onRenderRequest ? (
    <button
      type="button"
      className="floor-plan-room-render-btn floor-plan-selection-action-menu__render-btn"
      onClick={onRenderRequest}
      title="Render this room"
    >
      <span className="floor-plan-room-render-btn-icon" aria-hidden="true">
        <Video size={20} strokeWidth={2} />
      </span>
      <span>Render This Room</span>
    </button>
  ) : null;

  return (
    <SelectionActionMenu
      anchor={anchor}
      actions={actions}
      extraContent={extraContent}
      canvasBounds={viewportRect}
      blockedBounds={blockedBounds}
      ariaLabel="Room actions"
      onBoundsChange={onBoundsChange}
    />
  );
}

export default FloorPlanRoomActions;
